import React from 'react'
import { Header, TextoHeader } from './Styled'
import { firstName } from 'utils/helpers'

export default function Cabecalho ({ desconto, nameUser }) {

	const getMessage = () => {
		return desconto > 0 
		? `Parabéns, <strong>${firstName(nameUser)}</strong>. Você ganhou um <strong>desconto extra</strong> na <strong>Assinatura Vitalícia!</strong>`
		: `<strong>${firstName(nameUser)}</strong>, confira se você tem <strong>desconto extra</strong> para adquirir a <strong>Assinatura Vitalícia</strong>`
	}

	return (
		<Header>
			<TextoHeader dangerouslySetInnerHTML={{__html: getMessage()}} />
		</Header>
	)

}
